module.exports = {
  SERVICE: 'service',
  PRODUCT: 'product',
  VOUCHER: 'voucher',
  MEMBERSHIP: 'membership',
  DEPOSIT: 'deposit',
  UNTRACKED: 'untracked'
}
